// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"f847be5f","798":"ea60ba53","956":"f844dd78"}[chunkId] + ".chunk.js";
};